/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2022-01-04 15:49:19
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-04 15:49:44
 */
import request from "@/utils/request";
const requestUrl = window.env.userAccess;
const forgetPassword = {
  getVerificationCode: data => request({
    url: `${requestUrl}/api/v1/auth/getVerifyCode`,
    method: "post",
    data
  }),
  checkCode: data => request({
    url: `${requestUrl}/api/v1/auth/validateVerifyCode`,
    method: "post",
    data
  }),
  resizePassword: data => {
    data.confirmPassword = encodeURI(data.confirmPassword);
    data.confirmPassword = btoa(data.confirmPassword);
    data.newPassword = encodeURI(data.newPassword);
    data.newPassword = btoa(data.newPassword);

    /*
     * console.log('这是转码后的密码')
     * console.log(data)
     */
    return request({
      url: `${requestUrl}/api/v1/auth/password/reset`,
      method: "post",
      data
    });
  }
};

export {
  forgetPassword
};
